(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const searchPanel = document.querySelector('.header__search');
  const menuDrawer  = document.querySelector('menu-drawer');
  const toggleBtns  = document.querySelectorAll('.js-open-search');
  const closeBtns   = document.querySelectorAll('.js-close-search');

  function getIcons(btn) {
    return {
      search: btn.querySelector('.js-icon-search'),
      close:  btn.querySelector('.js-icon-close')
    };
  }

  function openSearch() {
    if (!searchPanel) return;
    searchPanel.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');

    toggleBtns.forEach(function(btn) {
      btn.classList.add('opacity-50');
      var icons = getIcons(btn);
      if (icons.search) icons.search.style.display = 'none';
      if (icons.close)  icons.close.style.display  = '';
      btn.setAttribute('aria-label', 'Close Search Bar');
    });

    if (menuDrawer) menuDrawer.closeMenuDrawer();

    /* Focus input */
    var input = searchPanel.querySelector('input[type="search"]');
    if (input) setTimeout(function() { input.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');

    toggleBtns.forEach(function(btn) {
      btn.classList.remove('opacity-50');
      var icons = getIcons(btn);
      if (icons.search) icons.search.style.display = '';
      if (icons.close)  icons.close.style.display  = 'none';
      btn.setAttribute('aria-label', 'Open Search Bar');
    });
  }

  /* Toggle buttons (open/close) */
  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      searchPanel && searchPanel.classList.contains('is-visible')
        ? closeSearch()
        : openSearch();
    });
  });

  /* All close buttons — inside bar + any others */
  closeBtns.forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-visible')) {
      closeSearch();
    }
  });

  /* ── Scroll header border ── */
  const header    = document.querySelector('.header-wrapper');
  const backToTop = document.querySelector('back-to-top');
  const headerH   = header ? header.offsetHeight : 0;

  window.addEventListener('scroll', function() {
    if (!header) return;
    if (window.scrollY >= headerH) {
      header.classList.add('border-b-half', 'border-green');
      if (backToTop) backToTop.classList.add('!visible', '!block', 'opacity-100');
    } else {
      header.classList.remove('border-b-half', 'border-green');
      if (backToTop) backToTop.classList.remove('!visible', '!block', 'opacity-100');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-carousel"] && !Shopify.designMode) return;
  try {
    

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    allowTouchMove: false
  });

  const thumbnailImages = document.querySelectorAll("[data-product-thumb]")

  thumbnailImages.forEach(thumb => {
    thumb.addEventListener('click', function(e) {
      productSlider.slideTo(e.target.dataset.productThumb);
    });
  });

  // Hover effect for main image
  const mainImageWrapper = document.querySelector('.product__media-list');
  if (mainImageWrapper) {
    mainImageWrapper.classList.remove('pointer-events-none'); // Enable pointer events for hover
    mainImageWrapper.addEventListener('mouseenter', () => {
      // Check if there is a second image (index 1) in the media list
      if (productSlider.slides.length > 1) {
        productSlider.slideTo(1); // Switch to the second image
      }
    });
    mainImageWrapper.addEventListener('mouseleave', () => {
      productSlider.slideTo(0); // Revert to the first image
    });
  }

  const sizeGuideTrigger = document.querySelector('[data-micromodal-trigger="size-guide"]');
  if (sizeGuideTrigger) {
    sizeGuideTrigger.addEventListener('click', (e) => {
    e.preventDefault()
    MicroModal.show(`${e.target.dataset.micromodalTrigger}`)
  })
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["post-carousel"] && !Shopify.designMode) return;
  try {
    
  const postsCarousels = document.querySelectorAll('.swiper[data-posts-carousel]') || null

  if( postsCarousels ) {
    postsCarousels.forEach(carousel => {
      const swiper = new Swiper(carousel, {
        slidesPerView: 1.125,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          600: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 16
          },
          1439: {
            slidesPerView: 4,
            spaceBetween: 16
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev', 
        }
      })
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => console.error('Product recommendations error:', e));
    };
    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
